import { render, staticRenderFns } from "./UsuarioCadastro.vue?vue&type=template&id=0e58b89a&"
import script from "./UsuarioCadastro.vue?vue&type=script&lang=js&"
export * from "./UsuarioCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports